import script from "./socialDuty.vue?vue&type=script&setup=true&lang=js"
export * from "./socialDuty.vue?vue&type=script&setup=true&lang=js"

import "./socialDuty.vue?vue&type=style&index=0&id=da7eb9c4&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da7eb9c4"]])

export default __exports__